import type { LocalizedSlugMap } from '~/types/cms';

export function useLocationI18nParams() {
    return useState<LocalizedSlugMap | null>('location-i18n-params', () => null);
}
